import { createSelector } from "reselect";

import type { MainNavigationStore } from "../stores/types";
import type { MainNavigationGroupItem } from "../types";

export const selectGroupCount = createSelector(
  (state: MainNavigationStore) => state.itemCounts,
  (_: MainNavigationStore, group: MainNavigationGroupItem) => group,
  (itemCounts, group): number => {
    const childItemIds = group.items.flatMap((section) => section.items.map((item) => item.id));

    return childItemIds.reduce((total: number, itemId: string) => {
      return total + (itemCounts[itemId] || 0);
    }, 0);
  }
);
